/*自定义的一些关于日期、日历的函数*/
import addDays from 'date-fns/addDays';
import addMonths from 'date-fns/addMonths';
import addYears from 'date-fns/addYears';
import endOfYear from 'date-fns/endOfYear';
import format from 'date-fns/format';
import getYear from 'date-fns/getYear';
import parse from 'date-fns/parse';
import parseISO from 'date-fns/parseISO';
import setDate from 'date-fns/setDate';
import startOfYear from 'date-fns/startOfYear';
import indexOf from 'lodash/indexOf';

export function fillYear(startDate: Date, endDate: Date = new Date()): Date[] {
  startDate = startOfYear(startDate);
  endDate = endOfYear(endDate);
  const resDate: Date[] = [];
  while (startDate <= endDate) {
    resDate.push(startDate);
    startDate = addYears(startDate, 1);
  }
  return resDate;
}

export function fillMonth(startDate: Date, endDate: Date = new Date()): Date[] {
  let currentDate = setDate(startDate, 1);
  const resDate: Date[] = [];
  while (currentDate <= endDate) {
    resDate.push(currentDate);
    currentDate = addMonths(currentDate, 1);
  }
  return resDate;
}

export function fillDay(startDate: Date, endDate: Date = new Date()): Date[] {
  let currentDate = setDate(startDate, 1);
  const resDate: Date[] = [];
  while (currentDate <= endDate) {
    resDate.push(currentDate);
    currentDate = addDays(currentDate, 1);
  }
  return resDate;
}

export function dateToNumber(date: number | Date): string {
  return format(date, 'yyyyMMdd');
}

export function numberToDate(date: number | string): Date {
  return parse(date.toString(), 'yyyyMMdd', new Date());
}

// 格式化x軸lable
export function formatDateAxisLabel(
  dateId: number | string,
  dateType: string, // 'year' | 'quarter' | 'month' | 'week' | 'day',
  yearNum: string,
  split: string
): { xAxisLabe: string; year: string; dateStr: string } {
  split = split || '.';

  let xAxisValue = '';
  let temYearNum = '';
  let timeDesc = '';
  dateId = (dateId || '').toString();
  const date = parseISO(dateId);
  temYearNum = getYear(date).toString();

  switch (dateType) {
    case 'year':
      timeDesc = getYear(date).toString();
      break;

    case 'quarter':
      timeDesc = format(date, '[Q]Q');
      break;

    case 'month':
      timeDesc = format(date, 'MM');

      break;

    case 'week':
      // timeDesc = format(date, 'W[w]');
      temYearNum = dateId.substr(0, 4);
      let weekNum = dateId.substr(4, 2); // 周为了与后台保持一致，直接从后台返回, 所以这里采取了截取的方式
      weekNum = indexOf(weekNum, '0') === 0 ? weekNum.substring(1, weekNum.length) : weekNum;
      timeDesc = weekNum;
      break;

    case 'day':
      timeDesc = format(date, 'M/d');
      break;
    default:
  }

  if (dateType === 'year') {
    return {
      xAxisLabe: temYearNum,
      year: yearNum,
      dateStr: temYearNum
    };
  }

  if (!yearNum || temYearNum !== yearNum) {
    yearNum = temYearNum;
    xAxisValue = yearNum + split;
  }

  xAxisValue += timeDesc;

  return {
    xAxisLabe: xAxisValue,
    year: yearNum,
    dateStr: yearNum + split + timeDesc
  };
}

/*
  将纯数字格式的值转为标准日期（yyyy-MM-dd）
*/
export function changeDateFormatForNumber(cellval: number | string) {
  let dateVal = (cellval + '').trim();

  // 如果不是标准的8位则补位
  if (dateVal.length === 6) {
    dateVal += '01';
  }

  if (dateVal.length === 4) {
    dateVal += '0101';
  }

  return format(new Date(dateVal.replace(/(\d\d\d\d)(\d\d)(\d\d)/, '$1-$2-$3')), 'yyyy-MM-dd');
}
